// Note:  this class provides enum-related static methods.
export class EnumUtil {
    // Note:  not save to use the static method twice in the same line of code.
    public static getEnumValues(enumType: Object): string[] {
        let values: string[] = [];

        for (let key in enumType) {
            let value: string = enumType[key];
            values.push(value);
        }

        return values;
    }
    /*
    public constructor() { }
    public getEnumValues(enumType: Object): string[] {
        let values: string[] = [];

        for (let value in enumType)
            values.push(value);

        return values;
    }
    */
}
